<template>
  <div>
    <Section :title="highlights.title">
      <Grid :columns="[3, 3, 3]" class="search-highlight__cards" :gutter="32">
        <GenericCard
          v-for="(cardItem, index) in highlights.items"
          :key="index"
          :thumbnail="cardItem.image.small"
          :title="cardItem.title"
          :description="cardItem.subtitle"
          class="search-highlight__card"
          @card-click="onCardClick(cardItem.id, cardItem.title)"
        />
      </Grid>
    </Section>
    <Section :title="sectionTypes.title">
      <Grid :columns="[5, 5]" :gutter="32" class="search-types__content">
        <Row
          v-for="(type, index) in sectionTypes.items"
          :key="index"
          :tabindex="0"
          :has-interaction="true"
          :chevron="true"
          class="search-types__row"
          data-testid="section-type__row"
          @click="onTypeClick(type.id, type.title)"
          @keydown.native.space.enter="onTypeClick(type.id, type.title)"
        >
          <template #top-left>
            <p class="search-types__text text-p-3">{{ type.title }}</p>
          </template>
        </Row>
      </Grid>
    </Section>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Section } from '@/modules/trade/components/Section';
import { HighLights, Sections } from '@/modules/trade/services/search';
import { GenericCard } from '../GenericCard';
import { Row, Grid } from '@warrenbrasil/nebraska-web';
import {
  trackHighlightClick,
  trackSectionClick
} from '@/modules/trade/views/SearchView/trackers';
import { StringFormatted } from '@/modules/trade/types';

@Component({
  components: {
    Section,
    GenericCard,
    Row,
    Grid
  }
})
export default class SectionsList extends Vue {
  @Prop({ type: Object, required: false })
  private highlights!: HighLights;

  @Prop({ type: Object, required: false })
  private sectionTypes!: Sections;

  @Prop({ type: Object, required: true })
  readonly filter!: StringFormatted;

  private onTypeClick(id: string, title: string) {
    trackSectionClick(this.filter.formatted, title);
    this.$router.push({ name: 'tradeSectionDetail', params: { id } });
  }

  private onCardClick(id: string, title: string) {
    trackHighlightClick(this.filter.formatted, title);
    this.$router.push({ name: 'tradeHighLightDetail', params: { id } });
  }

  // wait until api returns value
  private getVariationColor(value: number) {
    return {
      'text-p-3': true,
      'search-types__text--positive': value > 0,
      'search-types__text--negative': value < 0
    };
  }
}
</script>

<style lang="less" scoped>
.search-highlight {
  &__cards {
    margin-top: @size-spacing-x400;
  }
  &__card {
    margin-bottom: @size-spacing-x400;
  }
}

.search-types {
  &__content {
    margin-top: @size-spacing-x400;
  }
  &__text {
    color: @text-primary;
    &--positive {
      color: @monetary-positive;
    }
    &--negative {
      color: @monetary-negative;
    }
  }
}

@media @notebookUp {
  .search-highlight__card {
    margin-bottom: 0;
  }
}
</style>
